import React, { useRef } from 'react';
import styled from 'styled-components';
import { Section, Wrapper, Title, TitleRow } from './marketing.styles';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TestimonialSectionItem from './TestimonialSectionItem';
import { ChevronRight, ChevronLeft } from 'react-feather';
import Text, { TypeVariant } from 'shared/Typography';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

const IconWrap = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  color: white;
  position: absolute;
  cursor: pointer;
`;

const IconWrapLeft = styled(IconWrap)`
  left: -50px;

  @media (max-width: 1025px) {
    left: -20px;
  }
`;

const IconWrapRight = styled(IconWrap)`
  right: -50px;

  @media (max-width: 1025px) {
    right: -20px;
  }
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 24px;

  margin-left: 16.66667%;
  flex: 0 0 66.66667%;
  max-width: 66.66667%;

  @media (max-width: 1025px) {
    margin-left: 10%;
    flex: 0 0 80%;
    max-width: 80%;
  } ;
`;

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 },
    },
    {
      breakpoint: 1024,
      settings: { slidesToShow: 1 },
    },
  ],
};

interface TestimonialData {
  name: string;
  quote: string;
}

const data: TestimonialData[] = [
  {
    name: 'Tara Frost',
    quote:
      'Solin is absolutely amazing and everything I could have asked for. I was looking and looking for a new platform for my classes and Solin hit every nail on the head.',
  },
  {
    name: 'Pernilla Stryker',
    quote: 'The team from Solin has been absolute HEROs',
  },
  {
    name: 'Samantha Ortiz',
    quote:
      'Any creator who asks me about having an online site...I tell them you have to work with the team at Solin!',
  },
];

const TestimonialsSection = () => {
  const sliderRef = useRef<Slider>(null);

  const handlePrev = () => {
    if (sliderRef?.current) {
      sliderRef?.current?.slickPrev();
    }
  };

  const handleNext = () => {
    if (sliderRef?.current) {
      sliderRef?.current?.slickNext();
    }
  };

  return (
    <Section>
      <Wrapper>
        <Row>
          <Title>
            <TitleRow>
              <Text
                variant={TypeVariant.header02}
                as="h2"
                tablet={TypeVariant.subtitle01}
                textAlign="center"
              >
                Testimonials
              </Text>
            </TitleRow>
          </Title>
          <Container>
            <IconWrapLeft onClick={handlePrev}>
              <ChevronLeft />
            </IconWrapLeft>
            <Slider {...settings} ref={sliderRef}>
              {data.map(({ name, quote }, index) => (
                <TestimonialSectionItem key={index} name={name} quote={quote} />
              ))}
            </Slider>
            <IconWrapRight onClick={handleNext}>
              <ChevronRight />
            </IconWrapRight>
          </Container>
        </Row>
      </Wrapper>
    </Section>
  );
};

export default TestimonialsSection;
